import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme } from '@dxp-module/themes'
import { MyAccountAutoCompleteClasses } from '@dxp-module/themes/src'

const autoCompleteStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountAutoCompleteClasses
>(
  ({ transitions, typography, breakpoints }) => ({
    root: {
      paddingRight: 12,
    },
    dropdownIcon: {},
    dropdownIconOpened: {
      transform: 'rotate(180deg)',
    },
    input: {
      width: '100%',
      transition: transitions.create(['border-color', 'box-shadow']),
      padding: '16px 12px',
      '& input': {
        width: '100%',
        padding: 0,
        height: 'fit-content',
      },
    },
    noOptions: {
      [breakpoints.down('md')]: {
        fontSize: typography.fontSM,
      },
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXS,
      },
    },
  }),
  { name: 'MyAccount_Autocomplete' }
)

export default autoCompleteStyles
